import Image from "next/image";
import Link from "next/link";
import { IMG } from "@/lib/data";

export function Logo({ size = 44 }: { size?: number }) {
  return (
    <Link href="/" className="flex items-center gap-3" data-cursor="hover">
      <Image
        src={IMG.logo}
        alt="STO — Société de Tir d’Ostwald"
        width={size}
        height={size}
        className="rounded-full object-cover"
        priority
      />
      <span className="font-display text-xl tracking-[0.2em] md:text-2xl">STO</span>
    </Link>
  );
}
